// src/pages/DhrushtiDhyey.jsx
import React from "react";

export default function DhrushtiAniDhyey() {
    return (
        <div className="min-h-screen bg-gray-50 p-6 flex justify-center items-start">
            <div className="max-w-3xl w-full  p-8">
                <h1 className="text-3xl font-bold text-green-700 mb-6">
                    दृष्टी आणि ध्येय
                </h1>

                <ul className="list-disc list-inside text-gray-700 space-y-3">
                    <li>स्वच्छ, सुंदर व हरित ग्राम तयार करण्यासाठी विविध उपक्रम राबविणे.</li>
                    <li>महाराष्ट्र राज्य ग्रामीण जीवनोन्नती अभियानाद्वारे दारिद्रय निर्मुलनाचे उपक्रम चालविणे.</li>
                    <li>इंदिरा आवास योजनेअंतर्गत निवारा व निवारा विषयक सुविधा पुरविणे.</li>
                    <li>प्रशिक्षणातून विकास कार्यक्रमांतर्गत लोक प्रतिनिधींचे सक्षमीकरणाद्वारे पंचायती राज व्यवस्था बळकट करणे.</li>
                </ul>
            </div>
        </div>
    );
}
